'use client'

import { buttonVariants } from '@/components/Button'
import { I18NText } from '@/components/I18NText'
import { Heading } from '@/components/Typography/Heading'
import { Paragraph } from '@/components/Typography/Paragraph'
import { cn } from '@/lib'
import { TrackPage, type TrackingCodes } from '@/lib/userTracking'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import { register } from '../actions'
import { EmailForm } from './EmailForm'

export const RegisterForm: React.FC<{
	trackingCodes: TrackingCodes
	recaptchaSiteKey: string
}> = ({ trackingCodes, recaptchaSiteKey }) => {
	const [success, setSuccess] = useState(false)
	const searchParams = useSearchParams()
	return (
		<>
			<div className="flex flex-col gap-6">
				{!success && (
					<div className="flex flex-col items-center gap-4">
						<Heading level="1">
							<I18NText text="register.title" />
						</Heading>
						<Paragraph className="text-purple-700">
							<I18NText text="register.haveAccount" />{' '}
							<Link
								href={{
									pathname: '/sign-in',
									search: searchParams.toString(),
								}}
								className={cn(
									buttonVariants({ variant: 'text' }),
									'px-0 text-inherit',
								)}
							>
								<I18NText text="register.signIn" />
							</Link>
						</Paragraph>
					</div>
				)}

				<EmailForm
					mode="register"
					action={register}
					onSuccess={() => setSuccess(true)}
					email={searchParams.get('email') ?? undefined}
					recaptchaSiteKey={recaptchaSiteKey}
				/>
			</div>
			{success && <TrackPage trackingCodes={trackingCodes} />}
		</>
	)
}
